import React from 'react';

import { prop, defaultTo } from 'ramda';

import clear from '../../../images/ziprecruiter_logo.svg';

import { FOHImage } from '../../ingredients';

export const FOHZiprecruiterIcon = (props: any) => (
  <FOHImage
    source={{ uri: clear }}
    style={{ width: 93, height: 28, ...defaultTo({}, prop('style', props)) }}
  />
);
